import { getFormRequired } from '../../../../bereiche/dateneingabe/functions/getFormRequired';
import { IDs } from '../../../../helpers/IDs';
import { Import } from '../../../../bereiche/zusatztools/routinen/Import';
import { Md5 } from 'ts-md5/dist/md5';
import { StructureTool } from '../../../../core/forms/helpers/structure_tool';

export class ImportEmissionsfaktoren {

    public constructor(data: any, startRow: number, entity: string, dataDb: any, params: any, cancel?: () => void) {
        this.cancel = cancel;
        this.dataDb = dataDb || {};
        this.entity = entity;
        this.startRow = (+startRow || 1) - 1;
        this.init(data, params);
    }

    private autoCreate: any = {};
    private autoReferences: any = {};
    private bundle: any = {};
    private cancel: () => void;
    private columns: any = {};
    private curIndexData: number = 0
    private curIndexRow: number = 0
    private dataDb: any;
    private dataImport: any[] = [];
    private dataMeta: any = {};
    private dataSheet: any[] = [];
    private dataTable: any[] = [];
    private entity: string;
    private FileTool: any;
    private hashes: any = {};
    private mapBundle: any = {};
    private requiredFields: any = {};
    private curRowTable: any = {};
    private sheet: string = 'Data';
    private skipRows: any = {};
    private startRow: number;
    private structure: any = {};
    private uniques: any[];

    public getBundle(): any[] {
        return this.bundle;
    }

    public getData(): any[] {
        return this.dataImport;
    }

    private getDataMeta(): any {
        return { ...(this.dataMeta[this.curIndexData] || {}) };
    }

    public getDataTable(): any[] {
        return this.dataTable;
    }

    public getNumberErrors(): number {
        return Object.values(this.dataMeta || {}).reduce(
            (n: number, item: any) => n + Object.values(item).filter((meta: any) => meta.type === 'error').length, 0
        ) as number;
    }

    public getNumberRowsInsert(): number {
        return Object.values(this.dataMeta || {}).reduce(
            (n: number, item: any) => n + +(Object.values(item).findIndex((meta: any) => meta.type === 'insert') !== -1), 0
        ) as number;
    }

    public getAutoReferences(): any {
        return this.autoReferences;
    }

    private setAutoReference(value: string, key: string): void {
        if (!(this.autoReferences[key] || {}).values || value === '') {
            return;
        }
        this.autoReferences[key].values.add(value);
    }

    private getRowHashes(): any {
        const hashes: any = {};
        const withoutTids: number[] = [];
        let fallbackTid: number = 0;
        let tid: number = 0;

        this.uniques.forEach((unique: any, index: number) => {
            let hash: string = '';
            unique = unique || {};

            (unique.columns || []).forEach((column: string) => {
                hash += (this.curRowTable[column] || '').toString();
            });
            hash = Md5.hashAsciiStr(hash).toString();
            tid = (this.hashes[hash] || {}).tid || 0;
            fallbackTid = tid ? tid : fallbackTid;
            hashes[index] = { hash, tid };

            if (!tid && fallbackTid) {
                hashes[index] = { hash, tid: fallbackTid };
            } else if (!tid) {
                withoutTids.push(index);
            }
        });

        if (withoutTids.length && fallbackTid) {
            withoutTids.forEach((index: number) => hashes[index] = { ...hashes[index], tid: fallbackTid });
        }

        return hashes;
    }

    private getSheetData(): void {
        const dataImport: any[] = [];
        const dataTable: any[] = [];
        const importHashes: any = {};
        let lastRowHash: string = null;

        this.dataSheet.forEach((row: any[], indexRow: number) => {
            if (indexRow < this.startRow) {
                return;
            }
            const rowImport: any = {};
            this.curRowTable = {};
            let hasData: boolean = false;
            this.curIndexData = indexRow - this.startRow;
            this.curIndexRow = indexRow;

            for (let index: number = 0; index < row.length; ++index) {
                const value: any = row[index];
                const key: string = (this.columns[index] || {}).key || null;

                if (key) {
                    if (typeof value === 'undefined') {
                        continue;
                    }
                    const valueQuery: any = this.transformValue(value, key);
                    hasData = hasData || value !== '';
                    rowImport[key] = valueQuery;
                    this.setAutoReference(value, key);

                    if (this.bundle[key]) {
                        this.curRowTable[`${key}_orig`] = valueQuery;
                    }

                    if (!this.isValidValue(value, key)) {
                        this.skipRows[this.curIndexRow] = true;
                        this.setDataMeta({ info: 'Wert ist ungültig!', type: 'error', value }, this.curIndexData, key);
                    }
                    this.curRowTable[key] = !this.bundle[key] && this.mapBundle[key] ? valueQuery : value;
                }
            }

            if (!hasData) {
                return;
            }
            const hashes: any = this.getRowHashes();
            this.setRequiredFieldsDynamic();

            this.uniques.forEach((unique: any, index: number) => {
                const dataMeta: any = {};
                const hash: string = hashes[index].hash;
                const tid: string = hashes[index].tid;
                const uniqueImport: any = {};
                let skipUnique: boolean = false;
                rowImport.tid = tid || 0;
                const curRowHash: string = Md5.hashAsciiStr(JSON.stringify(rowImport)).toString();
                unique = unique || {};

                (unique.columns || []).forEach((column: string) => {
                    if (((this.dataMeta[this.curIndexData] || {})[column] || {}).type === 'error') {
                        skipUnique = true;
                    } else {
                        dataMeta[column] = { type: 'insert' };
                        uniqueImport[column] = rowImport[column];
                    }
                });
                const curImportHash: string = Md5.hashAsciiStr(JSON.stringify(uniqueImport)).toString();

                if (!this.hashes[hash] && !this.skipRows[this.curIndexRow] && !rowImport.tid && curRowHash !== lastRowHash) {
                    if (importHashes[curImportHash]) {
                        this.setErrorMultipleDataSets(dataMeta);
                    } else if (!this.setErrorRequiredField()) {
                        this.setDataMeta({ type: 'insert' }, this.curIndexData, '_row');
                        dataImport.push(rowImport);
                        importHashes[curImportHash] = true;
                    }
                } else if (!this.hashes[hash] && rowImport.tid) {
                    if (importHashes[curImportHash]) {
                        this.setErrorMultipleDataSets(dataMeta);
                    } else {
                        Object.keys(unique.values || {}).forEach((key: string) => {
                            if (this.isEmpty(this.curRowTable[key])) {
                                skipUnique = true;
                                return;
                            }
                            dataMeta[key] = { type: 'insert' };
                            uniqueImport[key] = rowImport[key];
                        });

                        if (!skipUnique) {
                            uniqueImport.tid = rowImport.tid;
                            this.setDataMeta(dataMeta, this.curIndexData);
                            dataImport.push(uniqueImport);
                            importHashes[curImportHash] = true;
                        }
                    }
                } else if (importHashes[curImportHash]) {
                    this.setErrorMultipleDataSets(dataMeta);
                }
                lastRowHash = curRowHash;
            });
            dataTable.push({ ...this.curRowTable, _meta: this.getDataMeta() });
        });
        this.dataImport = dataImport;
        this.dataTable = dataTable;
    }

    private init(data: any, params: any): void {
        let sheet: string = this.sheet;
        this.FileTool = new Import(data);

        if ((this.FileTool.getSheets() || []).indexOf(sheet) === -1) {
            const sheets: any[] = this.FileTool.getSheets(true) || [];

            if (sheets.length === 1) {
                sheet = sheets[0];
            } else {
                if (typeof this.cancel === 'function') {
                    this.cancel();
                }
                alert('Es wurde kein Datenblatt "Data" in der Datei gefunden!');
                return;
            }
        }
        this.autoCreate = params.autoCreate || {};
        this.dataSheet = this.FileTool.getSheetDataByName(sheet) || [];
        this.structure = new StructureTool(IDs.MOD_ETOOL_ADMIN).getStructure(IDs.MOD_ETOOL_ADMIN, this.entity) || {};
        this.uniques = params.uniques || [];
        this.setColumns();
        this.setHashes();
        this.setRequiredFields();
        this.getSheetData();
    }

    private isEmpty(value: any): boolean {
        return value === '' || typeof value === 'undefined' || value === null;
    }

    private isValidValue(value: any, key: string): any {
        return typeof this.mapBundle[key] !== 'undefined'
            ? value === '' || typeof this.mapBundle[key][value] !== 'undefined'
            : true;
    }

    private setBundle(data: any): void {
        const opts: any = (data || {}).OPTS;
        const bundle: any[] = (opts || {}).bundle || null;
        const entity: string = (opts || {}).ENTITY || null;
        const field: string = (opts || {}).INPUT || null;
        const index: string = (opts || {}).IDENTIFIER || null;
        const key: string = data.KEY || null;
        const module: string = (opts || {}).MODUL || null;

        if (this.autoCreate[key]) {
            if (Array.isArray(bundle) && entity) {
                this.autoReferences[key] = { entity, field, index, module, values: new Set() };
            }
            return;
        }

        if (Array.isArray(bundle)) {
            this.bundle[key] = bundle;
            this.setMapping(bundle, key);
        } else if (Array.isArray(opts)) {
            this.setMapping(opts, key);
        }
    }

    private setColumns(): void {
        const headers: string[] = this.dataSheet[0] || [];
        this.columns = {};

        (this.structure.ATTS || []).forEach((att: any) => {
            const name: string = att.NAME || null;
            const indexName: number = headers.indexOf(name);

            if (indexName !== -1) {
                this.columns[indexName] = { name, key: att.KEY };
                this.setBundle(att);
            }
        });
    }

    private setDataMeta(data: any, index: number, key?: string): void {
        this.dataMeta[index] = typeof key !== 'undefined'
            ? { ...(this.dataMeta[index] || {}), [key]: { ...(data || {}) } }
            : { ...(this.dataMeta[index] || {}), ...(data || {}) };
    }

    private setErrorMultipleDataSets(data: any): void {
        Object.keys(data).forEach((key: string) => this.setDataMeta(
            { info: 'Mehrfacher Datensatz!', type: 'error' }, this.curIndexData, key)
        );
    }

    private setErrorRequiredField(): boolean {
        let hasErrors: boolean = false;

        Object.keys(this.requiredFields).forEach((key: string) => {
            if (!this.isEmpty(this.curRowTable[key])) {
                return;
            }
            this.setDataMeta({ info: 'Pflichtfeld ohne Wert!', type: 'error' }, this.curIndexData, key);
            hasErrors = true;
        });

        return hasErrors;
    }

    private setHashes(): void {
        (this.dataDb[this.entity] || []).forEach((item: any) => {
            this.uniques.forEach((unique: any) => {
                let hash: string = '';
                unique = unique || {};

                (unique.columns || []).forEach((column: string) => {
                    hash += (item[column] || '').toString();
                });
                hash = Md5.hashAsciiStr(hash).toString();
                this.hashes[hash] = item;
            });
        });
    }

    private setMapping(data: any[], key: string): void {
        this.mapBundle[key] = {};

        (data || []).forEach((item: any) => {
            if (typeof item.tid !== 'undefined' && typeof item.name !== 'undefined') {
                this.mapBundle[key][item.name] = item.tid;
            } else if (typeof item.VALUE !== 'undefined' && typeof item.TITEL !== 'undefined') {
                this.mapBundle[key][item.TITEL] = item.VALUE;
            }
        });
    }

    private setRequiredFields(): void {
        this.requiredFields = getFormRequired(IDs.MOD_ETOOL_ADMIN, this.entity, null, this.dataDb);
    }

    private setRequiredFieldsDynamic(): void {
        let emptyUniques: number = 0;
        let valueKeys: string[] = [];

        this.uniques.forEach((unique: any, index: number) => {
            const lengthRequired: number = Object.keys(unique.required || {}).length;
            const requiredMissing: any = {};

            Object.keys(unique.required || {}).forEach((key: string, indexRequired: number) => {
                if (this.isEmpty(this.curRowTable[key])) {
                    requiredMissing[key] = true;
                }
                const lengthMissing: number = Object.keys(requiredMissing).length;

                if ((indexRequired + 1) === lengthRequired) {
                    Object.keys(unique.values || {}).forEach((keyValue: string) => {
                        valueKeys.push(keyValue)
                    });

                    if (lengthMissing !== lengthRequired) {
                        Object.keys(requiredMissing).forEach((key: string) => {
                            this.skipRows[this.curIndexRow] = true;
                            this.setDataMeta({ info: 'Pflichtfeld ohne Wert!', type: 'error' }, this.curIndexData, key);
                        });
                    } else {
                        ++emptyUniques;
                    }
                }
            });

            if ((index + 1) === this.uniques.length && emptyUniques === this.uniques.length) {
                this.skipRows[this.curIndexRow] = true;

                valueKeys.forEach((key: string) => {
                    this.setDataMeta({ info: 'Keine Werte!', type: 'error' }, this.curIndexData, key);
                });
            }
        });
    }

    private transformValue(value: any, key: string): any {
        return (this.mapBundle[key] || {})[value] || value;
    }
}
